<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const sections = [
  { title: "Prose Exercise Questions", to: "/11th/english/prose/", description: "Reading, while-reading aur exercise questions with solutions." },
  { title: "Poems Exercise Questions", to: "/11th/english/poems/", description: "Poem-related exercise support, explanation aur answer building." },
  { title: "Play Exercise Questions", to: "/11th/english/play/", description: "Play ke textbook-style questions aur structured answers." },
  { title: "Grammar & Composition Support", to: "/11th/english/grammar/", description: "Writing tasks aur composition items ke solved patterns." },
];

const proseUnits = [
  { title: "Unit 1: Khatam-un-Nabiyeen Hazrat Muhammad", to: "/11th/english/prose/khatam-un-nabiyeen-hazrat-muhammad/" },
  { title: "Unit 2: Responsibility of the Youth in Nation-Building", to: "/11th/english/prose/responsibility-of-the-youth-in-nation-building/" },
  { title: "Unit 4: Team Moon", to: "/11th/english/prose/team-moon/" },
  { title: "Unit 5: Impact of Global Warming on Pakistan", to: "/11th/english/prose/impact-of-global-warming-on-pakistan/" },
  { title: "Unit 7: What You Do is What You Are", to: "/11th/english/prose/what-you-do-is-what-you-are/" },
  { title: "Unit 8: Clean Water", to: "/11th/english/prose/clean-water/" },
  { title: "Unit 10: The Punishment of Shahpesh, the Persian, on Khipil, the Builder", to: "/11th/english/prose/the-punishment-of-shahpesh-the-persian-on-khipil-the-builder/" },
  { title: "Unit 12: The Impact of AI on Society, Human Relationships, and Ethics", to: "/11th/english/prose/the-impact-of-ai-on-society-human-relationships-and-ethics/" },
];

const faqs = [
  {
    question: "What does this solved-exercise page cover?",
    answer: "Yeh page prose, poems, play aur grammar ke exercise pages tak le jata hai.",
  },
  {
    question: "Are all linked units fully official textbook answer keys?",
    answer: "Nahi. Coverage broad aur usable hai, lekin strongest exact textbook-backed units abhi Team Moon aur AI hain.",
  },
  {
    question: "Where should I start for exercise-style prose prep?",
    answer: "Agar aap prose exercise ki tayari kar rahe hain to Team Moon ya AI se start karna behtar rahega.",
  },
];

usePageSeo({
  title: "11th Class English Solved Exercise Questions",
  description: "11th class English exercise questions with solutions ke liye prose, poems, play aur grammar routes.",
  keywords: "11th class english solved exercise, exercise questions with answers, first year english solved questions",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: [...sections, ...proseUnits].map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Solved Exercise", item: "/11th/english/solved-exercise/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Exercise Layer"
      title="11th Class English Solved Exercise"
      description="Yahan se aap exercise questions with answers wale pages khol sakte hain."
    />

    <EnglishSection
      title="Solved Exercise Routes"
      description="Jis section ki exercise dekhni ho, woh open karein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="section in sections"
          :key="section.to"
          :title="section.title"
          :description="section.description"
          :to="section.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Solved Prose Units"
      description="Prose ke ye chapters exercise questions ke liye useful hain."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="unit in proseUnits"
          :key="unit.to"
          :title="unit.title"
          description="Is chapter ki exercise aur answers dekhain."
          :to="unit.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="Solved exercise ke bare me aam sawalon ke jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
